import { render, staticRenderFns } from "./plazodias-form.vue?vue&type=template&id=4243f408&scoped=true"
import script from "./plazodias-form.vue?vue&type=script&lang=js"
export * from "./plazodias-form.vue?vue&type=script&lang=js"
import style0 from "./plazodias-form.vue?vue&type=style&index=0&id=4243f408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4243f408",
  null
  
)

export default component.exports